import KeyboardIcon from '@mui/icons-material/Keyboard';
import { IconButton, Tooltip } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useTranslations } from 'use-intl';

import { isTypingTarget } from '../hotkeys';
import HotkeySettingsDialog from './HotkeySettingsDialog';

const HotkeySettingsButton: FC = () => {
  const t = useTranslations('hotkeySettings.button');
  const [open, setOpen] = useState(false);

  // Ctrl+/ opens the shortcuts dialog. Always active so the feature can be
  // discovered and switched on even while disabled.
  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (
        event.ctrlKey &&
        !event.altKey &&
        !event.metaKey &&
        event.code === 'Slash' &&
        !isTypingTarget(event.target)
      ) {
        event.preventDefault();
        setOpen(true);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <>
      <Tooltip title={t('tooltip', { combo: 'Ctrl+/' })}>
        <IconButton color='primary' onClick={() => setOpen(true)} size='small'>
          <KeyboardIcon fontSize='small' />
        </IconButton>
      </Tooltip>
      {open && <HotkeySettingsDialog onClose={() => setOpen(false)} />}
    </>
  );
};

export default HotkeySettingsButton;
